/* eslint-disable react/destructuring-assignment */
import React from 'react';

import type { FC } from 'react';
import { Box, Divider, Paper, Stack, Typography } from '@packages/shared';
import { useIntl } from 'react-intl';
import { PromotionComponentLayout1Messages } from './messages';
import { Content } from '../Content';
import { usePriceFormater } from '../../../../hooks/usePriceFormater';
import { useInstallmentCalculatorTracking } from '../../../Tracking/hooks/useInstallmentCalculatorTracking';
import { BadgeDV } from '../../../BadgeDV';

export type Layout1Props = {
  /**
   * the single installment value from the calculation result as float (e.g. 13.37)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * open dialog handler
   */
  openInstallmentCalulatorHandler: () => void;
};

/**
 * Promotion component Layout 1
 *
 * component to promote the installment calculator in layout version 1
 *
 * */
export const Layout1: FC<Layout1Props> = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  openInstallmentCalulatorHandler,
}) => {
  const { formatMessage } = useIntl();
  const formatPrice = usePriceFormater('INSTALLMENTCALCULATOR');

  const { trackGlycerinLinkClick } = useInstallmentCalculatorTracking();

  return (
    <Paper
      variant="outlined"
      sx={{
        position: 'relative',
        mt: '8px',
      }}
      onClick={() => {
        openInstallmentCalulatorHandler();
        trackGlycerinLinkClick();
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          px: 1,
          bgcolor: 'common.white',
        }}
      >
        <BadgeDV text={formatMessage(PromotionComponentLayout1Messages.ChipLabel)} />
      </Box>

      <Stack
        direction="column"
        divider={<Divider flexItem orientation="horizontal" />}
        gap={1}
        py={1}
      >
        <Stack direction="row" flexWrap="nowrap" gap={5} px={2}>
          <Content
            smallText={formatMessage(PromotionComponentLayout1Messages.From)}
            bigText={formatPrice(singleInstallment, currency)}
          />
          <Content
            smallText={formatMessage(PromotionComponentLayout1Messages.InstallmentsPrefix)}
            bigText={formatMessage(PromotionComponentLayout1Messages.Installments, {
              installments: numberOfInstallments,
            })}
          />
        </Stack>
        <Box>
          <Typography variant="body2" textAlign="center" sx={{ cursor: 'pointer' }}>
            {formatMessage(PromotionComponentLayout1Messages.CtA)}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};
